export default '/creditlock';
